var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderMinus = function SvgFolderMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.169 3.4a2.49 2.49 0 0 1 2.073 1.116L11 5.641l.004.005a1.28 1.28 0 0 0 1.083.578h7.441a2.484 2.484 0 0 1 2.483 2.482v9.412a2.483 2.483 0 0 1-2.483 2.483H4.471a2.484 2.484 0 0 1-2.483-2.483V5.883A2.483 2.483 0 0 1 4.471 3.4zM4.471 4.6a1.284 1.284 0 0 0-1.283 1.283v12.235A1.283 1.283 0 0 0 4.47 19.4h15.058a1.285 1.285 0 0 0 1.282-1.282V8.706a1.283 1.283 0 0 0-1.282-1.282h-7.435v-.001a2.48 2.48 0 0 1-2.088-1.11l-.762-1.13-.004-.006A1.28 1.28 0 0 0 8.17 4.6zm10.352 8.212a.6.6 0 1 1 0 1.2H9.176a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgFolderMinus;